var _module_exports = "<div class=\"fancy-menu-details-title\">Log<sub>10</sub></div>\n<p>\n  Calculates the base-10 logarithm of a datapoint value.\n</p>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/LOG10/description.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;